import { render } from "./PartnerDetailsCard.vue?vue&type=template&id=eb891dec&scoped=true&ts=true"
import script from "./PartnerDetailsCard.vue?vue&type=script&lang=ts"
export * from "./PartnerDetailsCard.vue?vue&type=script&lang=ts"

import "./PartnerDetailsCard.vue?vue&type=style&index=0&id=eb891dec&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb891dec"]])

export default __exports__